import React from 'react';
import { Route } from 'react-router';
import { PublicLayout } from './guards';
import { ROUTES } from './constants';
import { Login } from '@src/pages/login/page';
import { Register } from '@src/pages/register/page';
import { ForgotPassword } from '@src/pages/forgot-password/page';

export function getPublicRoutes() {
  return [
    <Route element={<PublicLayout />} key="public">
      <Route path={ROUTES.LOGIN} element={<Login />} />
      <Route path={ROUTES.REGISTER} element={<Register />} />
      <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
    </Route>,
  ];
}
